import React, { useContext, useEffect, useState } from "react";
import '../../css/style.css';
import Menu from "src/components/common/Menu";
import Header from "src/components/common/Header";
import { MenuContext } from "src/context/MenuContext";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ScheduleDownloadHolidayTable from "src/components/schedule/ScheduleDownloadHolidayTable";
import ScheduleDownloadTable from "src/components/schedule/ScheduleDownloadTable";
import { getProjects } from "src/store/project";
import { getScheduleDownloadList, getWorkReportDownloadData, getUserList } from "src/store/scheduledownload";
import { format } from "date-fns";
import ScrollTop from 'src/components/common/ScrollTop';
import { getDailyWorks } from "src/store/schedule";
import * as XLSX from "xlsx";
import { getMcode } from "src/store/mcode";
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import CustomLoader from 'src/components/common/CustomLoader';

const ScheduleDownload = () => {

    const { visibleMenu } = useContext(MenuContext);
    const [workDateY, setWorkDateY] = useState(new Date().getFullYear());
    const [workDateM, setWorkDateM] = useState(new Date().getMonth() + 1);
    const [validationMessages, setValidationMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [yearList, setYearList] = useState(Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i));
    const [monthList, setMonthList] = useState(Array.from({ length: 12 }, (_, i) => i + 1));
    const dispatch = useDispatch();
    const [workDate, setWorkDate] = useState(new Date());
    const [selectedProjectId, setSelectedProjectId] = useState(0);
    const dailyWorkDownload = useSelector((state) => state.scheduledownload.data);
    const dailyWorkDownloadList = useSelector((state) => state.scheduledownload.allData);
    const getSingleUserData = useSelector((state) => state.scheduledownload.singleData);
    const holiday = useSelector((state) => state.mcode.data.holiday);
    const param = {
        work_date: workDate,
    }

    const handleProjectChange = (e) => {
        e.preventDefault();
        const selectedId = Number(e.target.value); // Ensure it's a number
        setSelectedProjectId(selectedId);
    };

    useEffect(() => {
        setLoading(true);
        const val = {
            id: id,
            workd_date_month: workDateM,
            work_date_year: workDateY,
        }

        const userParams = {
            id: id,
            workd_date_month: workDateM,
            work_date_year: workDateY,
            project_id: selectedProjectId
        }
        const userData = localStorage.getItem('user');
        let loginId = userData ? JSON.parse(userData).id : null;
        const value = {
            work_date: workDate,
            id: loginId,
        }
        dispatch(getWorkReportDownloadData(val))
            .then((response) => {
                if (response.payload?.errors) {
                      setValidationMessages(response.payload.errors)
                }
                if(response?.error){
                    setValidationMessages(response.error.message);
                }
                if (response.payload.status) {
                    setLoading(false);
                }
            });
        dispatch(getUserList(userParams));
        dispatch(getDailyWorks(value));

    }, [workDateM, workDateY, selectedProjectId]);

    const { id } = useParams();
    const params = {
        id: id,
        work_date: `${workDateM}-${workDateY}`
    }

    useEffect(() => {
        dispatch(getScheduleDownloadList(params));
        setWorkDate(format(new Date(), "yyyy-MM-dd"))
        dispatch(getProjects(param));
        dispatch(getMcode({ section_cd: 'holiday' }));
    }, []);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === "work_date_y") {
            setWorkDateY(value);
        } else if (name === "work_date_m") {
            setWorkDateM(value);
        }
    };

    const handleDownload = () => {
        const header = dailyWorkDownload.header;
        const body = dailyWorkDownload.body;

        // Combine header and body
        const data = [header, ...body];

        // Create a new worksheet
        const ws = XLSX.utils.aoa_to_sheet(data);

        // Calculate column widths dynamically
        const colWidths = header.map((_, colIndex) => {
            const maxLength = Math.max(
                ...data.map(row => (row[colIndex] ? row[colIndex].toString().length : 10)) // Default minimum width
            );
            return { wch: maxLength + 2 }; // Add padding
        });

        // Apply column widths
        ws['!cols'] = colWidths;

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate an Excel file and trigger the download
        const outputFilename = `schedule_list_${new Date().toLocaleString('en-US', { month: '2-digit', year: 'numeric' }).replace('/', '_')}.xlsx`;
        XLSX.writeFile(wb, outputFilename);
    };

    const handleMonthChange = (direction) => {
        setWorkDateY((prevYear) => {
            setWorkDateM((prevMonth) => {
                let newMonth = prevMonth + direction;
                let newYear = prevYear;

                if (newMonth < 1) {
                    newMonth = 12;
                    newYear -= 1;
                } else if (newMonth > 12) {
                    newMonth = 1;
                    newYear += 1;
                }

                return newMonth;
            });

            return prevYear;
        });
    };


    return (
        <div className="wrapper">
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? "menu-open" : "menu-closed"}>
                <div className="navbar navbar-fixed-top navbar-absolute">
                    <Header sx={{ mb: 4 }} />
                </div>
                {validationMessages && validationMessages.length > 0 && (
                    <div style={{ background: "#ffe4e2" }}>
                        <ValidationMessages
                            messages={validationMessages}
                            onClose={() => setValidationMessages([])}
                        />
                    </div>
                )}
                {loading ? <CustomLoader /> :
                    <>
                        <section className="container-fluid contents-top">
                            <form id="download_form" target="_blank">
                                <div className="text-left">
                                    <div style={{ marginBottom: 20 }}>
                                        {dailyWorkDownloadList?.user_list?.name}'s Work Report
                                    </div>
                                    <div id="button-area">
                                        <select name="work_date_y" value={workDateY} onChange={handleDateChange} style={{ height: 28 }}>
                                            {yearList.map((year) => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </select>
                                        /
                                        <select name="work_date_m" value={workDateM} onChange={handleDateChange} style={{ height: 28 }}>
                                            {monthList.map((month) => (
                                                <option key={month} value={month}>{month < 10 ? `0${month}` : month}</option>
                                            ))}
                                        </select>
                                        <div id="click-month-area">
                                            <button type="button" id="work_prev_month" className="btn btn-success" onClick={() => handleMonthChange(-1)}>
                                                <span id="prev_arrow"></span>Previous
                                            </button>
                                            <button type="button" id="work_next_month" className="btn btn-success" onClick={() => handleMonthChange(1)}>
                                                Next<span id="next_arrow"></span>
                                            </button>
                                            <button type="button" id="jq_download_btn" className="btn btn-success" onClick={() => handleDownload()}>
                                                Work Report Download
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <ScheduleDownloadHolidayTable
                                            holidays={getSingleUserData?.holidays}
                                            paramDate={`${workDateM}-${workDateY}`}
                                            currentWorkdays={dailyWorkDownloadList?.current_workdays}
                                            morning={dailyWorkDownloadList?.morning}
                                            afternoon={dailyWorkDownloadList?.afternoon}
                                            getSingleUserData={getSingleUserData}
                                        />
                                    </div>

                                    <table className="holiday_table">
                                        <caption style={{ width: 120 }}>Length of service</caption>
                                        <tbody>
                                            <tr>
                                                <th>
                                                    {dailyWorkDownloadList.service_length
                                                        ? `${dailyWorkDownloadList.service_length[0]} Year ${parseInt(dailyWorkDownloadList.service_length[1])} Month`
                                                        : "Data not registered"
                                                    }
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </section>
                        <section className="container">
                            <div className="section_project" style={{ textAlign: 'left' }}>
                                <select name="project_id" style={{ maxWidth: '100%', marginBottom: 10 }} onChange={handleProjectChange}>
                                    <option value="0">--------</option>
                                    {getSingleUserData.work_list?.length > 0 &&
                                        Array.from(
                                            new Map(
                                                getSingleUserData.work_list.map((project) =>
                                                    [`${project.t_project_id}-${project.project_name_abbreviation}-${project.client_name}`, project]
                                                )
                                            ).values()
                                        ).map((project) => (
                                            project.t_project_id !== 0 && 
                                            <option key={project.t_project_id} value={project.t_project_id}>
                                                {`[${project.client_name}] ${project.project_name_abbreviation}`}
                                            </option>
                                        ))
                                    }
                                </select>
                                <div>
                                    <ScheduleDownloadTable
                                        year={workDateY}
                                        month={workDateM}
                                        holidaysInMonth={getSingleUserData.holidays_in_month}
                                        getSingleUserData={getSingleUserData}
                                        holiday={holiday}
                                    />
                                </div>
                            </div>
                        </section>
                    </>}

            </div>
            <ScrollTop />
        </div>
    );
};

export default ScheduleDownload;